module.exports = __webpack_public_path__ + "img/np.78a39c51.svg";